export interface FlyToTargetOptions {
  text?: string;
  fromEl?: HTMLElement | null;
  toSelector: string;
  durationMs?: number;
  easing?: string;
  endScale?: number;
  className?: string;
  zIndex?: number | string;
}

export const flyToTarget = ({
  text = '+1',
  fromEl,
  toSelector,
  durationMs = 700,
  easing = 'cubic-bezier(0.22, 1, 0.36, 1)',
  endScale = 0.6,
  className = 'pointer-events-none select-none text-[28px] font-bold leading-[33px] bg-gradient-single-red text-transparent bg-clip-text',
  zIndex = 9999
}: FlyToTargetOptions): Promise<void> => {
  if (typeof document === 'undefined') return Promise.resolve();
  const targetEl = document.querySelector(toSelector) as HTMLElement | null;
  if (!targetEl) return Promise.resolve();

  const sourceRect = fromEl?.getBoundingClientRect();
  const targetRect = targetEl.getBoundingClientRect();

  const startX = sourceRect ? sourceRect.left + sourceRect.width / 2 : targetRect.left;
  const startY = sourceRect ? sourceRect.top + sourceRect.height / 2 : targetRect.top + 40;
  const endX = targetRect.left + targetRect.width / 2;
  const endY = targetRect.top + targetRect.height / 2;

  const floating = document.createElement('div');
  floating.textContent = text;
  floating.className = className;
  Object.assign(floating.style, {
    position: 'fixed',
    left: `${startX}px`,
    top: `${startY}px`,
    transform: 'translate(-50%, -50%) scale(1)',
    transition: `transform ${durationMs}ms ${easing}, opacity ${durationMs}ms ease`,
    zIndex: String(zIndex),
    willChange: 'transform, opacity',
    opacity: '1'
  } as CSSStyleDeclaration);

  document.body.appendChild(floating);

  // 실제 생성된 엘리먼트의 크기를 기준으로 정확한 보정
  const floatRect = floating.getBoundingClientRect();
  const dx = endX - startX;
  const dy = endY - startY;

  requestAnimationFrame(() => {
    floating.style.transform = `translate(${dx - floatRect.width / 2}px, ${dy - floatRect.height / 2}px) scale(${endScale})`;
    floating.style.opacity = '0';
  });

  return new Promise<void>((resolve) => {
    const cleanup = () => {
      floating.removeEventListener('transitionend', cleanup);
      if (floating.parentNode) {
        floating.parentNode.removeChild(floating);
      }
      resolve();
    };
    floating.addEventListener('transitionend', cleanup);
  });
};
